export enum EEnvironments {
  DEV = 'DEV',
  PROD = 'PROD',
  TEST = 'TEST',
  ACC = 'ACC',
}

export enum EBrowserType {
  Chrome = 'Chrome',
  Edge = 'Edge',
  Safari = 'Safari',
}

export enum ELocalStore {
  IsUnSupportedBrowserAck = 'isUnsBrowAck',
}

export enum EPageType {
  Home = 'Home',
}

export enum EPageName {
  Home = '/',
  Procos = '/procos',
  Feature = '/features',
  Pdm = '/pdm',
  Category = '/categories',
  Manage = '/manage',
}

export enum ETabName {
  PDM = 'pdm',
  ProCos = 'procos',
  Category = 'categories',
}

export const TabList = {
  Home: [
    {
      id: 'product',
      name: 'labels.product',
      path: EPageName.Home,
    },
    {
      id: 'manage',
      name: 'labels.manage',
      path: EPageName.Manage,
    },
  ],
  Pdm: [
    {
      id: ETabName.ProCos,
      name: 'labels.procos',
      path: EPageName.Procos,
    },
    {
      id: ETabName.PDM,
      name: 'labels.pdm',
      path: EPageName.Pdm,
    },
    {
      id: ETabName.Category,
      name: 'labels.categories',
      path: EPageName.Category,
    },
  ],
};

export const InludeCodeInView = true;

export const MultinumericTabs = [
  { id: 'multinumeric', name: 'labels.multiNumeric', path: 'manage' },
];

export const DefaultLanguage = {
  code: 'en-US',
  name: 'English',
};

export const Languages = [
  { code: 'en-US', name: 'English' },
  { code: 'fr-FR', name: 'French' },
  { code: 'de-DE', name: 'German' },
  { code: 'it-IT', name: 'Italian' },
];

export const popperModifier = [
  {
    name: 'flip',
    enabled: false,
    options: {
      altBoundary: false,
      rootBoundary: 'viewport',
    },
  },
  {
    name: 'preventOverflow',
    enabled: true,
    options: {
      altAxis: true,
      altBoundary: true,
      tether: true,
      rootBoundary: 'document',
    },
  },
];

export enum EFieldSize {
  Small = 'small',
  Large = 'large',
  Medium = 'medium',
}

export enum EKeyAction {
  Enter = 'Enter',
  Clear = 'clear',
}

export enum EUrlParams {
  ProductId = 'productCode',
  Search = 'search',
  Active = 'active',
  Page = 'Page',
  Limit = 'limit',
}

export const IdFormat = {
  Suffix: {
    LessFeature: '_LESS',
  },
  Regex: {},
};

export enum EApiType {
  SaveProperties = 'saveProperties',
  SaveMarketAssociations = 'saveMarketAssociations',
  SendNotification = 'sendNotification',
  Download = 'download',
  GetPropertyAssociations = 'getPropertyAssociations',
}

export enum EActionType {
  Edit = 'Edit',
  Create = 'Create',
  Delete = 'Delete',
  Add = 'Add',
}

export enum EDisplayType {
  Dialog = 'dialog',
  Toast = 'toast',
  None = 'none',
}

export const Status = {
  Active: 'active',
  InActive: 'inActive',
};
